// @flow
import React from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { CreatableMultiSelect } from 'dibs-elements/exports/CreatableMultiSelect';
import type { IntlShape } from 'react-intl';
import type { Project } from '../types.flow';
import type { NamedSelectOption } from 'dibs-elements/exports/types';

import styles from './styles/SelectProject.scss';

const messages = defineMessages({
    selectProjectPlaceholder: {
        id: 'dc.ProjectForms.SelectProject.selectProjectPlaceholder',
        defaultMessage: 'Select Or Create Project',
    },
});

type SelectProjectProps = {|
    intl: IntlShape,
    itemProjects: Array<Project>,
    onProjectCreation: (newProjectName: string) => void,
    onProjectSelection: (selectedOptions: Array<NamedSelectOption>) => void,
    userProjects: Array<Project>,
|};

export function SelectProject(props: SelectProjectProps) {
    const { intl, itemProjects, onProjectCreation, onProjectSelection, userProjects } = props;

    const projectOptions = userProjects.map((project: Project) => ({
        label: project.name || '',
        value: project.serviceId || '',
    }));

    return (
        <div>
            <div className={styles.explanation}>
                <FormattedMessage
                    id="dc.ProjectForms.SelectProject.selectProjectExplanation"
                    defaultMessage="Select from the dropdown to add one or more tags to this item."
                />
            </div>
            <CreatableMultiSelect
                createOptionHandler={({ inputValue }) => onProjectCreation(inputValue)}
                promptGenerator={inputValue => (
                    <FormattedMessage
                        id="dc.ProjectForms.SelectProject.createProjectPrompt"
                        defaultMessage="Create New Project: {inputValue}"
                        values={{ inputValue }}
                    />
                )}
                dataTn="select-project-for-item"
                name="select-project-for-item"
                placeholder={intl.formatMessage(messages.selectProjectPlaceholder)}
                values={itemProjects.map(project => project.serviceId || '')}
                autoFocus
                locale="en-us"
                options={projectOptions}
                onChange={onProjectSelection}
            />
        </div>
    );
}
export default injectIntl(SelectProject);
